
export const CONFIG = {
    quartersHistory: 4,
    quartersPredict: 1
}
